<div class="row vh-100" (click)="onValidateCookieUserView()">

  <div class="col-lg-12 login-form">
    <div class="row row-login">
      <div class="col-lg-12 text-center">
        <img src="./../../../assets/images/Logo_GEPP.3b4d362a.svg" alt="Emi plus logo" [width]="200" />
      </div>

      <div class="col-lg-12 mt-5 fmLogin">
        <div class="row">
          <div class="col-md-12 mb-5 text-center">
            <span class="login-lblWelcome">{{ 'login.lblWelcome' | translate }}</span>
            <br>
            <br>
            <span class="login-lblInstructions">{{ 'login.lblLoginInstructions' | translate }}</span>
          </div>
          <div class="col-md-12">
            <form [formGroup]="fmLogin" autocomplete="off">
              <!-- username -->
              <div class="form-group form-horizontal">
                <div class="input-group">
                  <mat-form-field appearance="outline">
                    <mat-label> {{ 'login.lblUser' | translate }}</mat-label>
                    <input [formControl]="f.username" type="text" #username matInput minlength="5" maxlength="50"
                      autofocus>
                    <mat-error *ngIf="f.username.hasError('required')">{{ 'common.lblErrorRequired' | translate
                      }}</mat-error>
                    <mat-error *ngIf="f.username.hasError('pattern')">{{ 'common.lblErrorFormating' | translate
                      }}</mat-error>
                    <mat-error *ngIf="f.username.hasError('minlength')">{{ 'login.lblErrorMinUser' | translate
                      }}</mat-error>
                  </mat-form-field>
                </div>
              </div>

              <!-- Password -->
              <div class="form-group form-horizontal">
                <div class="input-group">
                  <mat-form-field appearance="outline">
                    <mat-label> {{ 'login.lblPassword' | translate }}</mat-label>
                    <input [formControl]="f.password" [type]="show ? 'text' : 'password'" #password matInput
                      minlength="8" maxlength="12">
                    <mat-error *ngIf="f.password.hasError('required')">{{ 'common.lblErrorRequired' | translate
                      }}</mat-error>
                    <mat-error *ngIf="f.password.hasError('pattern')">{{ 'common.lblErrorFormating' | translate
                      }}</mat-error>
                    <mat-error *ngIf="f.password.hasError('minlength')">{{ 'login.lblErrorMinPassword' | translate
                      }}</mat-error>
                  </mat-form-field>
                  <div class="input-group-append-02">
                    <button class="btn btn-none text-secondary" (click)="onChangeInputPass()">
                      <i class="fa-solid fa-eye" *ngIf="!show"></i>
                      <i class="fa-solid fa-eye-slash" *ngIf="show"></i>
                    </button>
                  </div>
                </div>
              </div>


            </form>

            <div class="col-md-12 mt-3 text-center">
              <button [disabled]="fmLogin.invalid" class="btn btn-primary-02" (click)="loginUser(fmLogin.value)">
                {{ 'login.btnLogin' | translate }}
              </button>
            </div>

            <div class="col-md-12 mt-2 text-center" *ngIf="error">
              <div class="alert alert-danger">
                <small>{{ error }}</small>
              </div>
            </div>

          </div>
        </div>
      </div>

      <div class="col-lg-12 text-center mt-5">
        <small class="span-version-login">{{this._versionApp}}</small>
      </div>

    </div>
  </div>
</div>

<!-- loading -->
<div class="overlay-loading" [class.d-block]="this.waitFor" [class.d-none]="!this.waitFor"></div>
<div class="row text-center">
  <div *ngIf="this.waitFor" class="loadingGif">
    <div class="row">
      <div class="col-12 text-center">
        <h1 class="text-white text-black">
          <i class="fa-solid fa-spinner fa-spin-pulse text-white"></i>
        </h1>
      </div>
      <div class="col-12 text-white mt-4">
        {{ 'login.lblLoading' | translate }}
      </div>
    </div>
  </div>
</div>
<!-- loading -->